import { getPrototypeByID } from '@/libs/libraryGetters';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreUI } from '@/Store/storeUI';
import { useStoreItemsFromApi } from '@/Store/storeItemsFromApi';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { getCaseDataByModel, getDrawerSeparatorPrototypeById } from '@/libs/libGetters';
import { getIsDefaultColorSettings } from '@/libs/getIsDefaultColorSettings';

export function getFinalCasePrice(caseId: string) {
    const storeItemsFromApi = useStoreItemsFromApi();
    let finalCost = 0;
    // добавляем цену шкафа
    const selectedCaseId = useStoreProjectStructure().selectedCaseId;
    // if(!getIsDefaultColorSettings()&&selectedCaseId==caseId) return 0;

    let caseXmlId = '';
    if (caseId == selectedCaseId) {
        caseXmlId = useStoreCaseConfiguration().getSelectedCaseData?.xmlId ?? '';
    } else {
        caseXmlId = getCaseDataByModel(useStoreProjectStructure().getCaseDataById(caseId)?.selectedCaseModel)?.xmlId ?? '';
    }

    finalCost += +(storeItemsFromApi.getApiItemByXmlId(caseXmlId)?.price ?? 0);

    getCaseItemsGrouped(caseId).forEach(itemGroup => {
        let prototype = getPrototypeByID(itemGroup.prototypeId);
        if (!prototype) {
            prototype = getDrawerSeparatorPrototypeById(itemGroup.prototypeId);
        }
        const apiDataForGroup = storeItemsFromApi.getApiItemByXmlId(prototype.xmlId);

        if (!apiDataForGroup) return;
        let groupPrice = itemGroup.count * apiDataForGroup.price;
        // console.log('itemGroup',itemGroup,'apiDataForGroup',apiDataForGroup,'groupPrice',groupPrice);
        if ([ 'frame_hard_1000', 'frame_hard_2000', 'body_hard_1000', 'body_hard_2000' ].includes(itemGroup.prototypeId)) groupPrice = 0;
        finalCost += groupPrice;
    });
    // console.log('getFinalCasePrice',caseId, finalCost);
    // console.log('getCaseItemsGrouped(caseId)',getCaseItemsGrouped(caseId));
    useStoreProjectStructure().setCaseCostById(caseId, finalCost);
    return finalCost;
}

export function getCaseItemsGrouped(caseId: string) {
    const storeCaseConfiguration = useStoreCaseConfiguration();
    let items = [ ...useStoreProjectStructure().getCaseDataById(caseId)?.caseItems ?? [] ];
    if (useStoreProjectStructure().selectedCaseId == caseId) {
        items = [ ...storeCaseConfiguration.caseItems ];
    }
    //Назначение xmlId
    items = items.map(item => {
        return { ...item, xmlId: getPrototypeByID(item.prototypeId)?.xmlId??undefined };
    });
    const itemsCountMap = {};
    let key;

    //Drawers separators
    const drawerSeparators = (useStoreProjectStructure().selectedCaseId == caseId
        ? [ ...storeCaseConfiguration.drawerSeparators ?? [] ]
        : useStoreProjectStructure().getCaseDataById(caseId)?.drawerSeparators ?? []);
    drawerSeparators.forEach(separator => {
        if (separator.count == '0') return;
        const prototype = getDrawerSeparatorPrototypeById(separator.prototypeId);
        if (!prototype) console.warn('Drawer separator has no prototype', separator.prototypeId);
        const actualPrototypeId = items.find(item => item.xmlId == prototype?.xmlId)?.prototypeId;
        for (let i = 0; i < +separator.count; i++) {
            items.push({
                xmlId: prototype?.xmlId ?? '',
                prototypeId: actualPrototypeId ?? separator.prototypeId,
            });
        }
    });

    const caseModel = useStoreProjectStructure().selectedCaseId == caseId ?
        useStoreCaseConfiguration()?.selectedCaseModel : useStoreProjectStructure().getCaseDataById(caseId)?.selectedCaseModel;
    if (caseModel && caseModel.toLowerCase().includes('hard')) {
        const caseModels = {
            '1000': [ 'frame_hard_1000', 'frame_hard_1000', 'body_hard_1000' ],
            '2000': [ 'frame_hard_2000', 'frame_hard_2000', 'body_hard_2000' ],
        };
        const modelType = caseModel.includes('1000') ? '1000' : '2000';
        caseModels[modelType].forEach(itemId => items.unshift({ prototypeId: itemId }));
    }
    items.forEach(obj => {
        key = obj.xmlId?obj.xmlId:obj.prototypeId;

        if (itemsCountMap[key]) {
            itemsCountMap[key]++;
        } else {
            itemsCountMap[key] = 1;
        }
    });


    const result = [];
    // Перебираем массив объектов и добавляем только уникальные, добавляя свойство count
    items.forEach(obj => {
        const objKey = obj.xmlId?obj.xmlId:obj.prototypeId;
        if (!result.some(item =>{
            const itemKey=item.xmlId?item.xmlId:item.prototypeId;
            return itemKey === objKey;
        })) {
            result.push({ ...obj, count: itemsCountMap[objKey] });
        }
    });

    // console.log('get items grouped', items, result);
    return result;
}
